import React from "react";
import "./Experience.css";

const Experience = () => {
  return (
    <div className="experience-section">
      <div className="experience-layout">
        <div className="experience-left">
          {/* PROGRAMMING */}
          <div className="experience-card">
            <h2>Programming Experience</h2>
            <h3>
              <span>3</span>+ years (2022 - ongoing)
            </h3>
            <div className="experience-job">
              <h4 className="experience-h4">
                Product Engineering, Full-Stack Development & Technical
                Leadership
              </h4>
              <h5>What I did</h5>
              <p>
                Built and led development of client-facing websites and
                full-stack web applications using React, JavaScript, Node.js,
                HTML, and CSS/SCSS. At <i>Wikibusines</i>, I lead a small
                engineering team building websites, CRM functionality, and
                internal AI-assisted and multi-agent tools, coordinating
                priorities and reviewing implementation quality. At{" "}
                <i>The Chad Foundation</i>, I led end-to-end development of a 25+
                route React platform, supervising junior engineers, owning the
                design-to-development workflow, and approving UI/UX decisions in
                close work with the CEO. At <i>Handshake</i>, I evaluated
                AI-generated frontend, API, and full-stack code for correctness
                and production readiness using rubric-based review workflows.{" "}
                {/*At Boston University,
                I was a part of the Software Engineering project, an AI-powered
                bedtime story generator for preschoolers. I worked mainly on the front
                end using React and Vite, contributed to integrating OpenAI’s
                API, and ensured the UI was engaging and easy to use for young
                children. */}
              </p>
              <h5>What I learned</h5>
              <p>
                Grew from building features to leading delivery, owning
                technical execution from idea to release and coordinating
                engineers toward shared goals. Sharpened my command of code
                review, refactoring, and debugging complex UI and state issues,
                while learning to balance engineering decisions against product
                and stakeholder needs. Most of all, I learned how clear
                structure, sprint discipline, and steady communication turn a
                team's effort into shipped, production-ready software.
              </p>
            </div>
          </div>
          {/* GENERAL */}
          <div className="experience-card">
            <h2>General Tech & IT Experience</h2>
            <h3>
              <span>6</span> years (2016-2022)
            </h3>
            <div className="experience-job">
              <h4 className="experience-h4">
                Product Quality Management & SEO Writing
              </h4>
              <h5>What I did</h5>
              <p>
                Worked in product quality and SEO writing. Translated user feedback, complaints, and product pain
                points into actionable improvements for product and IT teams,
                and took part in product-improvement sessions identifying
                usability risks and operational bottlenecks. Improved public
                product reputation from 3.0 to 4.3 across major review platforms
                through structured feedback management. Also created monthly SMM
                content plans for corporate pages and wrote SEO texts to improve
                websites' visibility.
              </p>
              <h5>What I learned</h5>
              <p>
                Learned to approach problems as product problem-solving,
                turning real user pain points into concrete improvements for
                technical teams, often under time pressure. Became confident
                giving clear feedback and communicating across different
                backgrounds and functions. Understood how staying organized and
                meeting deadlines holds a product together, and how small,
                timely actions build the trust that strong teams and products
                depend on.
              </p>
            </div>
          </div>
        </div>

        <div className="experience-right">
          <h1 className="experience-section-h1">————— E X P E R I E N C E </h1>
        </div>
      </div>
    </div>
  );
};

export default Experience;
